import { CommCenterTicketId, PatientId } from "../../../../shared/schema/schema";
import useApi from "../../../../shared/hooks/useApi";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import CommunicationLogWrapper from "./CommunicationLogWrapper";
import { useCommCenterTicketPopup } from "../../hooks/useCommCenterTicketPopup";
import { EntityCommunicationsAdjustedFilters } from "../entity-communications/entity-communications.types";
import { filterCommunicationsLog } from "../entity-communications/entity-communications.utils";

interface Props {
  patientId: PatientId;
  filters?: EntityCommunicationsAdjustedFilters;
  emptyCommunicationsComponent?: React.ReactNode;
}

function PatientCommunicationLog(props: Props) {
  const { queries } = useApi();
  const ticketPopup = useCommCenterTicketPopup();

  const query = useQuery({
    ...queries.patient.communicationLog(props.patientId),
    placeholderData: keepPreviousData,
    select: (data) => filterCommunicationsLog(data, props.filters),
  });

  const handleClickTicket = (ticketId: CommCenterTicketId) => {
    ticketPopup.open({
      primaryEntity: "Patient",
      patientId: props.patientId,
      defaultTicketId: ticketId,
      contactDetails: null,
    });
  };

  return (
    <CommunicationLogWrapper
      emptyCommunicationsComponent={props.emptyCommunicationsComponent}
      query={query}
      onClickTicket={handleClickTicket}
    />
  );
}

export default PatientCommunicationLog;
